import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(relativeTime);

function getDateFromNow(date: string | number) {
  const x = dayjs(date);
  const now = dayjs();
  return x.from(now);
}

export default getDateFromNow;
